(function () {
  function setActiveTab(section, index) {
    const tabs = section.querySelectorAll("[data-el-habit-tab]");
    const panels = section.querySelectorAll("[data-el-habit-panel]");

    tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    panels.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle("is-active", isActive);
      if (isActive) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "");
      }
    });
  }

  function initHabitTabs(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll("[data-el-habit-tabs]").forEach((section) => {
      const tabs = section.querySelectorAll("[data-el-habit-tab]");
      if (!tabs.length) return;

      tabs.forEach((tab, index) => {
        if (tab.dataset.initialized === "true") return;
        tab.dataset.initialized = "true";

        tab.addEventListener("click", () => {
          setActiveTab(section, index);
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initHabitTabs());
  } else {
    initHabitTabs();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initHabitTabs(event.target);
  });
})();
